// extracted by mini-css-extract-plugin
export default {"notice":"Notice-module__notice--FruA5"};